import { render, staticRenderFns } from "./CardSuperior.vue?vue&type=template&id=70a0eb15&scoped=true&"
import script from "./CardSuperior.vue?vue&type=script&lang=js&"
export * from "./CardSuperior.vue?vue&type=script&lang=js&"
import style0 from "./CardSuperior.vue?vue&type=style&index=0&id=70a0eb15&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a0eb15",
  null
  
)

export default component.exports